import { useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";

export const DashboardDetailEmptyState: FC = () => {
	const { t } = useResource();
	const { spacingTokens } = useTheme();

	return (
		<EmptyListSkeleton
			label={t(Resources.Dashboard.EmptyList.label)}
			description={t(Resources.Dashboard.EmptyList.description)}
			height="auto"
			py={spacingTokens.xl}
			skeletonSize="lg"
		/>
	);
};
